"use client";

import {
	DiscoveryButton as UiDiscoveryButton,
	type DiscoveryButtonProps,
} from "@repo/ui/aops-components/DiscoveryButton";
import {trackDiscoveryLinkClick} from "@/lib/discoveryLinkTracking";

export function DiscoveryButton(
	props: Omit<DiscoveryButtonProps, "onLinkClick">
) {
	return (
		<UiDiscoveryButton
			{...props}
			onLinkClick={(href) =>
				trackDiscoveryLinkClick(href, "discovery_button", props.button.text)
			}
		/>
	);
}
